/* RESTAURATIONSBRANCHEN - TEMA 1 */
const gameSteps = [
	{
		id: 'theme-2-1-video1',
		type: 'video',
		title: {
			da: 'Se filmen sammen',
			en: `Watch the video together`
		},
		videos: [
			{id: {da: '7cPh3yGEzzE', en: '5reqwIrgnGY'}, thumbnail: 'theme-2-1-video1'}
		],
		nextBtn: null,
		nextBtnConditions: []
	},
	{
		id: 'theme-2-1-question1',
		type: 'questions',
		title: {
			da: 'Vælg en handling',
			en: `Choose an action`
		},
		text: {
			da: `Hvad synes I Louise skal gøre?`,
			en: `What do you think Louise should do?`
		},
		nextBtn: null,
		questions: [
			{
				id: 'theme-2-1-question1-question',
				type: 'multiple-choice',
				options: [
					{
						id: 1,
						text: {
							da: 'Louise skal foreslå at Claus taler med køkkenet om situationen.',
							en: `Louise should suggest that Claus talks to the kitchen about the situation.`
						},
					},
					{
						id: 2,
						text: {
							da: 'Louise skal tale med Claus, så der er et system til at håndtere, når folk bliver syge en anden gang.',
							en: `Louise should talk to Claus about having a system for when people get sick in the future. `
						}
					},
				]
			}
		]
	},
	{
		id: 'theme-2-1-video2',
		type: 'video',
		title: {
			da: 'Se filmen sammen',
			en: `Watch the video together`
		},
		videos: [
			{
				id: {da: '0-w-No2UWwI', en: 'M21aVCO7I5w'}, 
				thumbnail: 'theme-2-1-video2a',
				conditions: [{type: 'question-option-selected', questionId: 'theme-2-1-question1-question', optionId: 1}]
			},
			{
				id: {da: 'bztZAG2dPK8', en: 'KhUOjK_qnb8'}, 
				thumbnail: 'theme-2-1-video2b',
				conditions: [{type: 'question-option-selected', questionId: 'theme-2-1-question1-question', optionId: 2}]
			},
		],
		nextBtn: null,
		nextBtnConditions: []
	},
	{
		id: 'theme-2-1-dilemma',
		type: 'questions',
		subtype: 'dilemma',
		title: {
			da: `Tal i gruppen`,
			en: `Discuss in your group`
		},
		text: {
			da: `Forestil jer, at Louise beder om hjælp, men ikke får en god reaktion. Hvordan kan hun ændre kulturen, så de i højere grad hjælper hinanden?
				<br /><br />Tal om det i gruppen, og vælg en mulighed.`,
			en: `Imagine that Louise asks for help but doesn’t get a positive response. How can she change the culture so that people will be more willing to help one another?
				<br /><br />Discuss this in the group and choose one option.`
		},
		nextBtn: null,
		questions: [
			{
				id: 'theme-2-1-dilemma-question',
				type: 'multiple-choice',
				subtype: 'dilemma',
				options: [
					{
						id: 1,
						text: {
							da: 'Louise skal tilbyde at hjælpe andre. Den slags spreder sig stille og roligt.',
							en: `Louise should offer to help others. It's a habit that can easily spread.`
						},
					},
					{
						id: 2,
						text: {
							da: 'Louise skal blive ved med at bede om hjælp, når hun har brug for det.',
							en: `Louise should keep asking for help when she needs it.`
						}
					},
					{
						id: 3,
						text: {
							da: 'Louise skal tage det op på et fælles møde.',
							en: `Louise should put it up for discussion in a meeting.`
						}
					},
				]
			}
		]
	},
	// {
	// 	id: 'theme-2-1-dilemma-result',
	// 	type: 'dilemma-result',
	// 	dilemmaGameStepId: 'theme-2-1-dilemma',
	// 	dilemmaQuestionId: 'theme-2-1-dilemma-question',
	// 	title: {
	// 		da: 'Andre, der har prøvet forløbet, har svaret:',
	// 		en: `Others who've used this tool have answered:`
	// 	},
	// 	nextBtn: {
	// 		da: 'Videre',
	// 		en: `Next`
	// 	}
	// },
	{
		id: 'theme-2-1-discussion',
		type: 'text',
		title: {
			da: 'Jeres arbejdsplads',
			en: `Your workplace`
		},
		text1: {
			da: `Hvordan vil I gerne tages imod af jeres kollegaer, når I har brug for hjælp?`,
			en: `How would you like your colleagues to respond when you need help?`
		},
		text2: {
			da: 'Tal om det i gruppen i tre-fem minutter, og tryk så "Videre".',
			en: `Discuss this in the group for three to five minutes, then click "Next".`
		},
		nextBtn: {
			da: 'Videre',
			en: `Next`
		},
		nextBtnConditions: [],
	},
	{
		id: 'theme-2-1-survey',
		type: 'survey',
		title: {
			da: 'Individuelle spørgsmål',
			en: `Individual questions`
		},
		text: {
			da: `I skal nu svare individuelt på nogle spørgsmål. Scan koden med jeres egne telefoner. Når alle spillere har scannet QR-koden, skal spilleren med denne telefon trykke "Videre" for at gå til de individuelle spørgsmål.`,
			en: `You will now answer some questions individually. Scan the code using your own phones. Once all players have scanned the QR code, the player with this phone should tap "Next" to proceed to the individual questions.`
		},
		questions: [
			{ 
				id: 'theme-2-1-survey-q1',
				type: 'multiple-choice',
				// title: {
				// 	da: 'Spørgsmål 1',
				//	en: 'Question 1'
				// },
				text: {
					da: `Hvad oplever du som de største udfordringer i forhold til hjælpsomhed på din arbejdsplads?
						<br /><br /><strong>Vælg 1 eller 2 svar og tryk så "Videre".</strong>`,
					en: `What do you see as the biggest challenges when it comes to willingness to help in your place of work?
						<br /><br /><strong>Choose 1 or 2 answers and then press "Next".</strong>`
				},
				maxNumberOfAnswers: 2,
				options: [
					{
						id: 1,
						text: {
							da: `Det er svært at spørge om hjælp uden at skulle forklare sig.`,
							en: `It's hard to ask for help without having to explain oneself.`
						},
					},
					{
						id: 2,
						text: {
							da: `Vi glemmer at tilbyde hjælp, når nogen har travlt.`,
							en: `We forget to offer help when someone's busy.`
						}
					},
					{
						id: 3,
						text: {
							da: `Tonen kan være hård, når vi spørger om hjælp fra hinanden.`,
							en: `The tone can be hard when we ask each other for help.`
						}
					},
					{
						id: 4,
						text: {
							da: `Der er ikke tid i hverdagen, til at vi kan hjælpe hinanden.`,
							en: `Normally we don't have time to help each other.`
						}
					},
					{
						id: 5,
						text: {
							da: `Det er uklart, hvem man kan støtte sig til, når man har brug for det.`,
							en: `It's not clear whom you can get to help, when you need it.`
						}
					},
					{
						id: 6,
						text: {
							da: `Vi siger for sjældent tak eller anerkender hinandens hjælp.`,
							en: `Vi rarely say thank you or acknowledge each other for helping.`
						}
					}
				]
			},
			{
				id: 'theme-2-1-survey-q2',
				type: 'multiple-choice',
				// title: {
				// 	da: 'Spørgsmål 2',
				//	en: 'Question 2'
				// },
				text: {
					da: `Hvad er vigtigst for dig i forhold til hjælpsomhed på din arbejdsplads?
						<br /><br /><strong>Vælg 1 eller 2 svar og tryk så "Videre".</strong>`,
					en: `What is most important to you when it comes to helping each other in your place of work?
						<br /><br /><strong>Choose 1 or 2 answers and then press "Next".</strong>`
				},
				maxNumberOfAnswers: 2,
				options: [
					{
						id: 1,
						text: {
							da: `At det er nemt at bede om hjælp uden at skulle forklare sig.`,
							en: `That it's easy to ask for help without having to explain oneself.`
						}
					},
					{
						id: 2,
						text: {
							da: `At kollegaer selv tilbyder hjælp, når de kan se, at nogen har brug for det.`,
							en: `That colleagues offer to help if they can see, that someone needs it.`
						}
					},
					{
						id: 3,
						text: {
							da: `At vi kan sige ja eller nej til at hjælpe hinanden på en god måde.`,
							en: `That we can say yes or no to helping in a good way.`,
						}
					},
					{
						id: 4,
						text: {
							da: `At der er tid og overskud i hverdagen til at hjælpe hinanden.`,
							en: `That we have time and energy to help each other.`
						}
					},
					{
						id: 5,
						text: {
							da: `At jeg kan hjælpe uden at blive kritiseret, hvis jeg gør det anderledes end normalt.`,
							en: `That I can help without being criticised because I do it in a different way.`
						}
					},
					{
						id: 6,
						text: {
							da: `At vi husker at sige tak og anerkende, når vi hjælper hinanden.`,
							en: `That we remember to say thank you and acknowledge when we help each other.`
						}
					}
				]
			}
		],
		finishedTitle: {
			da: `Tak for dine svar!`,
			en: `Thank you for answering!`
		},
		finishedText: {
			da: `Øvelsen er nu slut. Gå tilbage til start-lokalet.`,
			en: `The exercise is now over. Please return to the starting room.`
		},
		nextBtn: {
			da: 'Videre',
			en: `Next`
		},
	}
];
	

export {
	gameSteps
};